module.exports = __webpack_public_path__ + "img/finance-employee.1e3e6ff7.png";